import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function useRouterScrollToTop() {
  const location = useLocation()
  const { pathname, search } = location

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname, search])

  return null
}
